module.exports = __webpack_public_path__ + "static/media/xray-training-medial-nonflex4.d81e8263.png";